module.exports = __webpack_public_path__ + "static/media/tracker-app.0d25e046.svg";